import React from "react";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { getOperatorCatalog } from "./filterBuilderConstants";
import FilterConditionInput from "./FilterConditionInput";

const FilterConditionRow = ({
  condition, fields, fieldMap,
  updateConditionField, updateConditionOperator, updateConditionValue, removeConditionById,
}) => {
  const { t } = useTranslation();
  const operatorCatalog = getOperatorCatalog(t);
  const fieldMeta = fieldMap[condition.field] || {};
  const operators = operatorCatalog[fieldMeta.type || "string"] || operatorCatalog.string;

  return (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-3 space-y-2 md:space-y-0 border border-dashed border-border rounded-md p-3 bg-card">
      <div className="flex-1">
        <Label className="text-xs uppercase text-muted-foreground">{t("filterComp.field")}</Label>
        <Select value={condition.field} onValueChange={(val) => updateConditionField(condition.id, val)}>
          <SelectTrigger className="w-full md:w-48">
            <SelectValue placeholder={t("filterComp.selectField")} />
          </SelectTrigger>
          <SelectContent>
            {fields.map((field) => (
              <SelectItem key={field.id} value={field.id}>
                {field.labelKey ? t(field.labelKey) : field.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex-1">
        <Label className="text-xs uppercase text-muted-foreground">{t("filterComp.operator")}</Label>
        <Select value={condition.operator} onValueChange={(val) => updateConditionOperator(condition.id, val)}>
          <SelectTrigger className="w-full md:w-48">
            <SelectValue placeholder={t("filterComp.operator")} />
          </SelectTrigger>
          <SelectContent>
            {operators.map((op) => (
              <SelectItem key={op.value} value={op.value}>{op.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex-1">
        <Label className="text-xs uppercase text-muted-foreground">{t("filterComp.value")}</Label>
        <div>
          <FilterConditionInput
            condition={condition}
            fieldMeta={fieldMeta}
            updateConditionValue={updateConditionValue}
            updateConditionOperator={updateConditionOperator}
          />
        </div>
      </div>

      <div className="pt-3 md:pt-6">
        <Button variant="ghost" size="icon" onClick={() => removeConditionById(condition.id)}>
          <Trash2 className="w-4 h-4 text-destructive" />
        </Button>
      </div>
    </div>
  );
};

export default FilterConditionRow;
